"use client";

import clsx from "clsx";
import React, { FC, HTMLAttributes, PropsWithChildren, ReactElement, useCallback, useMemo, useRef } from "react";
export interface CheckboxGroupProps extends PropsWithChildren, Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  name: string;
  value: any[];
  onChange: (value: any) => void;
  className?: string;
  label?: string;
  vertical?: boolean;
}
const CheckboxGroup: FC<CheckboxGroupProps> = ({
  children,
  name,
  value,
  onChange,
  className,
  label,
  vertical,
  ...props
}) => {
  const checkboxesRef = useRef<any[]>([]);
  const handleCheckboxChange = useCallback(() => {
    onChange(checkboxesRef.current.filter(checkbox => checkbox.checked).map(checkbox_0 => checkbox_0.value));
  }, [onChange]);
  const checkboxes = useMemo(() => {
    return React.Children.map(children as ReactElement<any>[], (child: ReactElement<any>, i) => {
      return React.cloneElement(child, {
        ref: (el: any) => {
          checkboxesRef.current[i] = el;
        },
        onChange: handleCheckboxChange,
        name: name,
        checked: value?.includes(child.props.value) || false,
        className: "flex-1"
      });
    });
  }, [children, name, value, handleCheckboxChange]);
  return <div {...props}>
      <label className="mb-2xs text-app-body-2 block">{label}</label>
      <div className={clsx("flex ", className, {
      "flex-col gap-y-xs": vertical,
      "flex-wrap gap-x-3xs gap-y-xs": !vertical
    })}>
        {checkboxes}
      </div>
    </div>;
};
export default CheckboxGroup;